/**
 * @generated SignedSource<<63ff68d21c339471e9e4027253d6fd24>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "phone"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shortId"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "phone",
        "variableName": "phone"
      },
      {
        "kind": "Variable",
        "name": "shortId",
        "variableName": "shortId"
      }
    ],
    "concreteType": "Authentication",
    "kind": "LinkedField",
    "name": "authenticateWithParticipantShortId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jwt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "apiAuthenticateWithParticipantShortIdMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "apiAuthenticateWithParticipantShortIdMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7a79f967589763d59ac6229e6a5b2c00",
    "id": null,
    "metadata": {},
    "name": "apiAuthenticateWithParticipantShortIdMutation",
    "operationKind": "mutation",
    "text": "mutation apiAuthenticateWithParticipantShortIdMutation(\n  $shortId: String!\n  $name: String\n  $phone: String\n  $email: String\n) {\n  authenticateWithParticipantShortId(shortId: $shortId, name: $name, phone: $phone, email: $email) {\n    jwt\n  }\n}\n"
  }
};
})();

node.hash = "f50835a39a7acb01c05649a1b583b4ba";

module.exports = node;
